'use strict';

// TODO: Some of these are unused, some are outdated,
// some are used but directly by their string values.
// Need to clean this up.

module.exports = {
   // General
  STAMPSY_VISIT: 'stampsy.visit',
  STAMPSY_SIGNUP: 'stampsy.signup',
  FACEBOOK_BUTTON_CLICK: 'facebook_button.click',

  // Editor
  EDITOR_VIEW: 'editor.view',
  EDITOR_COMPOSE_VIEW: 'editor.compose.view',
  EDITOR_PREVIEW_VIEW: 'editor.preview.view',
  EDITOR_HELP_SHOW: 'editor.help.show',

  // Editor actions
  EDITOR_COVER_CLEAR: 'editor.cover.clear',
  EDITOR_COVER_DROP: 'editor.cover.drop',
  EDITOR_GALLERY_DROP: 'editor.gallery.drop',
  EDITOR_POSTER_DROP: 'editor.poster.drop',
  EDITOR_GRABBOX_DELETE: 'editor.grabbox.delete',
  EDITOR_GRABBOX_DROP: 'editor.grabbox.drop',
  EDITOR_GRABBOX_FAIL: 'editor.grabbox.fail',
  EDITOR_GRABBOX_QUEUE: 'editor.grabbox.queue',
  EDITOR_GRABBOX_UPLOAD: 'editor.grabbox.upload',
  EDITOR_SECTIONS_ADD: 'editor.sections.add',
  EDITOR_SECTIONS_DELETE: 'editor.sections.delete',
  EDITOR_SECTIONS_DROP: 'editor.sections.drop',

  // Feed
  FEED_VIEW: 'feed.view',

  // Zines
  ZINES_VIEW: 'zines.view',

  // Forms
  FORMS_ABOUT_SHOW: 'forms.about.show',
  FORMS_FEEDBACK_SHOW: 'forms.feedback.show',
  FORMS_FEEDBACK_SEND: 'forms.feedback.send',
  FORMS_SEND_INVITE_SHOW: 'forms.send_invite.show',
  FORMS_SEND_INVITE_SEND: 'forms.send_invite.send',
  FORMS_SETTINGS_SHOW: 'forms.settings.show',
  FORMS_SETTINGS_SEND: 'forms.settings.send',
  FORMS_EDIT_ZINE_SHOW: 'forms.edit_zine.show',
  FORMS_FINISH_SIGNUP_SHOW: 'forms.finish_signup.show',
  FORMS_FINISH_SIGNUP_SEND: 'forms.finish_signup.send',
  FORMS_REQUEST_RESET_PASSWORD_SHOW: 'forms.request_reset_password.show',
  FORMS_REQUEST_RESET_PASSWORD_SEND: 'forms.request_reset_password.send',
  FORMS_RESET_PASSWORD_SHOW: 'forms.reset_password.show',
  FORMS_RESET_PASSWORD_SEND: 'forms.reset_password.send',
  FORMS_LOGIN_SHOW: 'forms.login.show',
  FORMS_LOGIN_SEND: 'forms.login.send',
  FORMS_SIGNUP_SHOW: 'forms.signup.show',
  FORMS_AMBASSADOR_REQUEST_SHOW: 'forms.ambassador_request.show',

  // Stamp
  STAMP_VIEW: 'stamp.view',

  // Stamp actions
  STAMP_DELETE: 'stamp.delete',
  STAMP_EDIT: 'stamp.edit',
  STAMP_PUBLISH: 'stamp.publish',
  STAMP_LIKE: 'stamp.like',
  STAMP_UNLIKE: 'stamp.unlike',
  STAMP_SHARE: 'stamp.share',

  // User profile
  USER_VIEW: 'user.view',
  USER_SHARE: 'user.share',
  USER_LATEST_VIEW: 'user.latest.view',
  USER_CURATED_VIEW: 'user.curated.view',
  USER_LIKES_VIEW: 'user.likes.view',
  USER_STATS_VIEW: 'user.stats.view',
  USER_STATS_ADMIN_VIEW: 'user.stats_admin.view',

  // Zine
  ZINE_VIEW: 'zine.view',
  ZINE_SHARE: 'zine.share',
  ZINE_TRENDING_VIEW: 'zine.trending.view',
  ZINE_LATEST_VIEW: 'zine.latest.view',
  ZINE_PENDING_VIEW: 'zine.pending.view',

  // Zine actions
  ZINE_ACCEPT_STAMP: 'zine.accept_stamp',
  ZINE_DECLINE_STAMP: 'zine.decline_stamp',
  ZINE_ADD_STAMP: 'zine.add_stamp',
  ZINE_REMOVE_STAMP: 'zine.remove_stamp',
  ZINE_SUBMIT_STAMP: 'zine.submit_stamp',
  ZINE_CREATE: 'zine.create',
  ZINE_EDIT: 'zine.edit',

  // About
  ABOUT_VIEW: 'about.view',

  // Notifications
  NOTIFICATION_EMAIL_CONFIRMATION_RESEND: 'notification.email_confirmation.resend',
  NOTIFICATION_EMAIL_CONFIRMATION_CANCEL: 'notification.email_confirmation.cancel',

  // MISC
  STAMP_ACTION_BUY_IN_ITUNES: 'stamp.action.buy_in_itunes'
};



/** WEBPACK FOOTER **
 ** ./constants/AnalyticsEvents.js
 **/